/* eslint-disable */
require('parsleyjs');

const formValidation = function formValidation() {
  let $form = $('.gform_wrapper form');
  let ignored = false;

  $form.parsley({
    trigger: 'change',
    excluded: 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], :hidden',

    // ui
    focus: 'none',
  });

  $('.gform_previous_button').click(function () {

    ignored = true;

    window.Parsley.off('field:error');
    window.Parsley.off('field:success');
    window.Parsley.off('form:error');
    window.Parsley.off('form:submit');

    $form.off('submit');

    $form.parsley().off('field:error');
    $form.parsley().off('form:submit');
    $form.parsley().reset();
    $form.parsley().destroy();


    $form.trigger('submit', [true]);

    // eval(this.onclick);
  });

  // Handles invalid complex fields on form load - this can happen if a user somehow submits
  // a form that isn't valid, but for some reason isn't hit by the Parsley validator.
  $(document).on('gform_post_render', function (e, formId) {
    let $form = $(`#gform_${formId}`);
    let $field = $form.find('.gfield_complex [required]');

    $field.each(function () {
      let $this = $(this);
      let $parent = $this.closest('.gfield, span').first()

      $parent.addClass(
        $this.parsley().refresh().isValid() ? 'gfield_success' : 'gfield_error'
      );
    });
  });

  // On blur, initialize validation for the field specifically.
  $('.gform_wrapper input, .gform_wrapper textarea, .gform_wrapper select').on('blur', function () {
    let $this = $(this);

    setTimeout(() => {
      let $p = $this.parsley();

      // $p.reset();
      $p.validate();
    }, 50);
  });

  window.Parsley
    .on('form:submit', function (e) {
      this.$element.find('.gform_submit_button').addClass('is-submitting');
    })
    .on('field:error', function () {
      setTimeout(() => {
        if (! ignored) {
          if (this.$element.is(':radio')) {
            this.$element
              .closest('.gfield_radio, span')
              .addClass('gfield_error')
              .removeClass('gfield_success');
          }

          if (this.$element.is(':checkbox')) {
            this.$element
              .closest('.gfield_checkbox, span')
              .addClass('gfield_error')
              .removeClass('gfield_success');
          } else {
            this.$element
              .closest('.gfield, span')
              .addClass('gfield_error')
              .removeClass('gfield_success');
          }
        }
      }, 20)
    })
    .on('form:error', function () {
      let t = this;

      setTimeout(function () {
        if (!ignored) {
          t.$element.find('.parsley-error').get(0).focus();
        }
      }, 20);
    })
    .on('field:success', function () {
      // On a successful validation, add classes to the appropriate
      // parent element instead of the element itself.
      let $parent = this.$element.closest('.gfield, span');
      let $radioParent = this.$element.closest('.gfield_radio, span');
      let $checkboxParent = this.$element.closest('.gfield_checkbox, span');

      // No value on the element at all - remove any success class
      if (this.$element.prop('required') && this.$element.val().length === 0) {

        if (this.$element.is(':radio')) {
          $radioParent.removeClass('gfield_success').addClass('gfield_error');
        } if (this.$element.is(':checkbox')) {
          $checkboxParent.removeClass('gfield_success').addClass('gfield_error');
        } else {
          $parent.removeClass('gfield_success').addClass('gfield_error');
        }
        return;
      }

      if (this.$element.is(':radio')) {
        $radioParent.removeClass('gfield_error').addClass('gfield_success');
      } if (this.$element.is(':checkbox')) {
        $checkboxParent.removeClass('gfield_error').addClass('gfield_success');
      } else {
        $parent.removeClass('gfield_error').addClass('gfield_success');
      }
    });

  $form.on('submit', function (e) {
    if (!ignored) {
      e.preventDefault();
    }

    let $this = $(this);
    let $form = $(this).parsley();
    let $btn = $this.find('.gform_submit_button');

    $btn.addClass('is-submitting');

    $form.validate();

    if ($form.isValid()) {

      setTimeout(() => {
        $btn.addClass('is-form-successful');

        $this.get(0).submit()
      }, 500);
    } else {
      $btn.removeClass('is-submitting');
    }
  });
};

formValidation();


// WEBPACK FOOTER //
// ./scripts/lib/form.js